module.exports = __webpack_public_path__ + "img/my-banner@2x.30ce2210.png";